namespace $.$$ {

	type $shm_hitalama_text_editor_paste = { owner: $giper_baza_entity, files: File[], input: HTMLTextAreaElement, value: string, from: number, to: number, inserted: boolean, pending?: Promise<unknown>, prepared?: { text: string, cursor: number } }

	export class $shm_hitalama_text_editor extends $.$shm_hitalama_text_editor {

		private operations = new WeakMap< ClipboardEvent, $shm_hitalama_text_editor_paste >()

		@ $mol_mem
		paste_listener() {
			if( !this.enabled() || !this.images_enabled() ) return null
			const owner = this.owner()
			if( !owner.can_change() ) return null
			return new this.$.$mol_dom_listener( this.Edit().dom_node(), 'paste', event => this.paste( event, owner ), { passive: false } )
		}

		paste( event?: ClipboardEvent | null, owner = this.owner() ) {
			if( !event ) return null
			let operation = this.operations.get( event )
			if( !operation ) {
				if( event.defaultPrevented || !this.enabled() || !this.images_enabled() ) return null
				const input = event.target
				if( !( input instanceof HTMLTextAreaElement ) || input.disabled || input.readOnly ) return null
				const files = Array.from( event.clipboardData?.items ?? [] )
					.filter( item => item.kind === 'file' && item.type.startsWith( 'image/' ) )
					.map( item => item.getAsFile() ).filter( ( file ): file is File => file !== null )
				if( !files.length ) return null
				if( !owner.can_change() ) return null
				operation = { owner, files, input, value: input.value, from: input.selectionStart, to: input.selectionEnd, inserted: false }
				this.operations.set( event, operation )
			}
			event.preventDefault()
			event.stopPropagation()
			if( operation.pending || operation.inserted ) return null
			// A native clipboard event is the asynchronous boundary, outside wire rendering.
			const current = operation
			operation.pending = Promise.all( operation.files.map( file => file.arrayBuffer().then( buffer => new Uint8Array( buffer ) ) ) )
				.then( bytes => Promise.all( current.files.map( ( file, index )=>
					$mol_wire_async( this.$.$shm_hitalama_text_images ).attach( current.owner, file, bytes[index], current, index )
				) ) )
				.then( links => $mol_wire_async( this ).commit( current, links ) ).catch( error => {
				this.$.$shm_hitalama_notifications.error( String( error?.message ?? error ), 'Не удалось вставить изображение' )
			} )
			return null
		}

		@ $mol_action
		commit( operation: $shm_hitalama_text_editor_paste, links: string[] ) {
			if( operation.inserted ) return
			const { input, owner } = operation
			if( !input.isConnected || !this.enabled() || !this.images_enabled() || this.owner().link().str !== owner.link().str || !owner.can_change() ) return
			if( !operation.prepared ) {
				const markup = links.map( uri => `![Изображение](${ uri })` ).join( '\n' )
				// Keep edits made while reading the clipboard bytes. Never restore a stale snapshot.
				const [ from, to ] = input.value === operation.value
					? [ operation.from, operation.to ] : [ input.selectionStart, input.selectionEnd ]
				operation.prepared = { text: input.value.slice( 0, from ) + markup + input.value.slice( to ), cursor: from + markup.length }
				if( document.activeElement === input ) {
					input.setSelectionRange( from, to )
					document.execCommand( 'insertText', false, markup )
				}
			}
			this.value( operation.prepared.text )
			this.selection([ operation.prepared.cursor, operation.prepared.cursor ])
			operation.inserted = true
		}

	}

}
